//***Reservation***
///foodtablereservation/list
export const FOOD_TABLE_RESERVATION_LIST = "FOOD_TABLE_RESERVATION_LIST";
export const FOOD_TABLE_RESERVATION_LIST_SUCCESS =
  "FOOD_TABLE_RESERVATION_LIST_SUCCESS";
export const FOOD_TABLE_RESERVATION_LIST_FAIL =
  "FOOD_TABLE_RESERVATION_LIST_FAIL";
///foodtablereservation/list/today
export const FOOD_TABLE_RESERVATION_LIST_TODAY =
  "FOOD_TABLE_RESERVATION_LIST_TODAY";
export const FOOD_TABLE_RESERVATION_LIST_TODAY_SUCCESS =
  "FOOD_TABLE_RESERVATION_LIST_TODAY_SUCCESS";
export const FOOD_TABLE_RESERVATION_LIST_TODAY_FAIL =
  "FOOD_TABLE_RESERVATION_LIST_TODAY_FAIL";
///foodtablereservation/list/tomorrow
export const FOOD_TABLE_RESERVATION_LIST_TOMORROW =
  "FOOD_TABLE_RESERVATION_LIST_TOMORROW";
export const FOOD_TABLE_RESERVATION_LIST_TOMORROW_SUCCESS =
  "FOOD_TABLE_RESERVATION_LIST_TOMORROW_SUCCESS";
export const FOOD_TABLE_RESERVATION_LIST_TOMORROW_FAIL =
  "FOOD_TABLE_RESERVATION_LIST_TOMORROW_FAIL";
///foodtablereservation/list/future
export const FOOD_TABLE_RESERVATION_LIST_FUTURE =
  "FOOD_TABLE_RESERVATION_LIST_FUTURE";
export const FOOD_TABLE_RESERVATION_LIST_FUTURE_SUCCESS =
  "FOOD_TABLE_RESERVATION_LIST_FUTURE_SUCCESS";
export const FOOD_TABLE_RESERVATION_LIST_FUTURE_FAIL =
  "FOOD_TABLE_RESERVATION_LIST_FUTURE_FAIL";
///foodtablereservation/data
export const FOOD_TABLE_RESERVATION_DATA = "FOOD_TABLE_RESERVATION_DATA";
export const FOOD_TABLE_RESERVATION_DATA_SUCCESS =
  "FOOD_TABLE_RESERVATION_DATA_SUCCESS";
export const FOOD_TABLE_RESERVATION_DATA_FAIL =
  "FOOD_TABLE_RESERVATION_DATA_FAIL";
///foodtablereservation/create
export const FOOD_TABLE_RESERVATION_CREATE = "FOOD_TABLE_RESERVATION_CREATE";
export const FOOD_TABLE_RESERVATION_CREATE_SUCCESS =
  "FOOD_TABLE_RESERVATION_CREATE_SUCCESS";
export const FOOD_TABLE_RESERVATION_CREATE_FAIL =
  "FOOD_TABLE_RESERVATION_CREATE_FAIL";
////foodtablereservation/import
export const FOOD_TABLE_RESERVATION_IMPORT = "FOOD_TABLE_RESERVATION_IMPORT";
export const FOOD_TABLE_RESERVATION_IMPORT_SUCCESS =
  "FOOD_TABLE_RESERVATION_IMPORT_SUCCESS";
export const FOOD_TABLE_RESERVATION_IMPORT_FAIL =
  "FOOD_TABLE_RESERVATION_IMPORT_FAIL";
///foodtablereservation/update
export const FOOD_TABLE_RESERVATION_UPDATE = "FOOD_TABLE_RESERVATION_UPDATE";
export const FOOD_TABLE_RESERVATION_UPDATE_SUCCESS =
  "FOOD_TABLE_RESERVATION_UPDATE_SUCCESS";
export const FOOD_TABLE_RESERVATION_UPDATE_FAIL =
  "FOOD_TABLE_RESERVATION_UPDATE_FAIL";
///foodtablereservation/delete
export const FOOD_TABLE_RESERVATION_DELETE = "FOOD_TABLE_RESERVATION_DELETE";
export const FOOD_TABLE_RESERVATION_DELETE_SUCCESS =
  "FOOD_TABLE_RESERVATION_DELETE_SUCCESS";
export const FOOD_TABLE_RESERVATION_DELETE_FAIL =
  "FOOD_TABLE_RESERVATION_DELETE_FAIL";

//***Area***
///foodtablearea/list
export const FOOD_TABLE_AREA_LIST = "FOOD_TABLE_AREA_LIST";
export const FOOD_TABLE_AREA_LIST_SUCCESS = "FOOD_TABLE_AREA_LIST_SUCCESS";
export const FOOD_TABLE_AREA_LIST_FAIL = "FOOD_TABLE_AREA_LIST_FAIL";

///foodtablearea/data
export const FOOD_TABLE_AREA_DATA = "FOOD_TABLE_AREA_DATA";
export const FOOD_TABLE_AREA_DATA_SUCCESS = "FOOD_TABLE_AREA_DATA_SUCCESS";
export const FOOD_TABLE_AREA_DATA_FAIL = "FOOD_TABLE_AREA_DATA_FAIL";

///foodtablearea/create
export const FOOD_TABLE_AREA_CREATE = "FOOD_TABLE_AREA_CREATE";
export const FOOD_TABLE_AREA_CREATE_SUCCESS = "FOOD_TABLE_AREA_CREATE_SUCCESS";
export const FOOD_TABLE_AREA_CREATE_FAIL = "FOOD_TABLE_AREA_CREATE_FAIL";

///foodtablearea/update
export const FOOD_TABLE_AREA_UPDATE = "FOOD_TABLE_AREA_UPDATE";
export const FOOD_TABLE_AREA_UPDATE_SUCCESS = "FOOD_TABLE_AREA_UPDATE_SUCCESS";
export const FOOD_TABLE_AREA_UPDATE_FAIL = "FOOD_TABLE_AREA_UPDATE_FAIL";

///foodtablearea/delete
export const FOOD_TABLE_AREA_DELETE = "FOOD_TABLE_AREA_DELETE";
export const FOOD_TABLE_AREA_DELETE_SUCCESS = "FOOD_TABLE_AREA_DELETE_SUCCESS";
export const FOOD_TABLE_AREA_DELETE_FAIL = "FOOD_TABLE_AREA_DELETE_FAIL";

///foodtable/list
export const FOOD_TABLE_LIST = "FOOD_TABLE_LIST";
export const FOOD_TABLE_LIST_SUCCESS = "FOOD_TABLE_LIST_SUCCESS";
export const FOOD_TABLE_LIST_FAIL = "FOOD_TABLE_LIST_FAIL";

///foodtable/data
export const FOOD_TABLE_DATA = "FOOD_TABLE_DATA";
export const FOOD_TABLE_DATA_SUCCESS = "FOOD_TABLE_DATA_SUCCESS";
export const FOOD_TABLE_DATA_FAIL = "FOOD_TABLE_DATA_FAIL";

///foodtable/create
export const FOOD_TABLE_CREATE = "FOOD_TABLE_CREATE";
export const FOOD_TABLE_CREATE_SUCCESS = "FOOD_TABLE_CREATE_SUCCESS";
export const FOOD_TABLE_CREATE_FAIL = "FOOD_TABLE_CREATE_FAIL";

///foodtable/update
export const FOOD_TABLE_UPDATE = "FOOD_TABLE_UPDATE";
export const FOOD_TABLE_UPDATE_SUCCESS = "FOOD_TABLE_UPDATE_SUCCESS";
export const FOOD_TABLE_UPDATE_FAIL = "FOOD_TABLE_UPDATE_FAIL";

///foodtable/delete
export const FOOD_TABLE_DELETE = "FOOD_TABLE_DELETE";
export const FOOD_TABLE_DELETE_SUCCESS = "FOOD_TABLE_DELETE_SUCCESS";
export const FOOD_TABLE_DELETE_FAIL = "FOOD_TABLE_DELETE_FAIL";

///foodtablereservation/search
export const FOOD_TABLE_RESERVATION_SEARCH = "FOOD_TABLE_RESERVATION_SEARCH";
export const FOOD_TABLE_RESERVATION_SEARCH_SUCCESS =
  "FOOD_TABLE_RESERVATION_SEARCH_SUCCESS";
export const FOOD_TABLE_RESERVATION_SEARCH_FAIL =
  "FOOD_TABLE_RESERVATION_SEARCH_FAIL";

///foodtableblock/list
export const FOOD_TABLE_BLOCK_LIST = "FOOD_TABLE_BLOCK_LIST";
export const FOOD_TABLE_BLOCK_LIST_SUCCESS = "FOOD_TABLE_BLOCK_LIST_SUCCESS";
export const FOOD_TABLE_BLOCK_LIST_FAIL = "FOOD_TABLE_BLOCK_LIST_FAIL";

///foodtableblock/data
export const FOOD_TABLE_BLOCK_DATA = "FOOD_TABLE_BLOCK_DATA";
export const FOOD_TABLE_BLOCK_DATA_SUCCESS = "FOOD_TABLE_BLOCK_DATA_SUCCESS";
export const FOOD_TABLE_BLOCK_DATA_FAIL = "FOOD_TABLE_BLOCK_DATA_FAIL";

///foodtableblock/create
export const FOOD_TABLE_BLOCK_CREATE = "FOOD_TABLE_BLOCK_CREATE";
export const FOOD_TABLE_BLOCK_CREATE_SUCCESS =
  "FOOD_TABLE_BLOCK_CREATE_SUCCESS";
export const FOOD_TABLE_BLOCK_CREATE_FAIL = "FOOD_TABLE_BLOCK_CREATE_FAIL";

///foodtableblock/update
export const FOOD_TABLE_DIARY_BLOCK_UPDATE = "FOOD_TABLE_DIARY_BLOCK_UPDATE";
export const FOOD_TABLE_DIARY_BLOCK_UPDATE_SUCCESS =
  "FOOD_TABLE_DIARY_BLOCK_UPDATE_SUCCESS";
export const FOOD_TABLE_DIARY_BLOCK_UPDATE_FAIL =
  "FOOD_TABLE_DIARY_BLOCK_UPDATE_FAIL";

///foodtableblock/delete
export const FOOD_TABLE_BLOCK_DELETE = "FOOD_TABLE_BLOCK_DELETE";
export const FOOD_TABLE_BLOCK_DELETE_SUCCESS =
  "FOOD_TABLE_BLOCK_DELETE_SUCCESS";
export const FOOD_TABLE_BLOCK_DELETE_FAIL = "FOOD_TABLE_BLOCK_DELETE_FAIL";

///foodtablereservationtableassignment/update
export const FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE =
  "FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE";
export const FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE_SUCCESS =
  "FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE_SUCCESS";
export const FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE_FAIL =
  "FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE_FAIL";

///foodtablereservationtableassignment/cancel
export const FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL =
  "FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL";
export const FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL_SUCCESS =
  "FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL_SUCCESS";
export const FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL_FAIL =
  "FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL_FAIL";

// Task 24607 - Unallocated tray
export const FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN =
  "FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN";
export const FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN_SUCCESS =
  "FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN_SUCCESS";
export const FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN_FAIL =
  "FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN_FAIL";
export const FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ASSIGN =
  "FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ASSIGN";
export const FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ASSIGN_SUCCESS =
  "FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ASSIGN_SUCCESS";
export const FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ASSIGN_FAIL =
  "FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ASSIGN_FAIL";

///foodtablediaryrule/list
export const FOOD_TABLE_DIARY_RULE_LIST = "FOOD_TABLE_DIARY_RULE_LIST";
export const FOOD_TABLE_DIARY_RULE_LIST_SUCCESS =
  "FOOD_TABLE_DIARY_RULE_LIST_SUCCESS";
export const FOOD_TABLE_DIARY_RULE_LIST_FAIL =
  "FOOD_TABLE_DIARY_RULE_LIST_FAIL";

///foodtablediaryrule/data
export const FOOD_TABLE_DIARY_RULE_DATA = "FOOD_TABLE_DIARY_RULE_DATA";
export const FOOD_TABLE_DIARY_RULE_DATA_SUCCESS =
  "FOOD_TABLE_DIARY_RULE_DATA_SUCCESS";
export const FOOD_TABLE_DIARY_RULE_DATA_FAIL =
  "FOOD_TABLE_DIARY_RULE_DATA_FAIL";

///foodtablediaryrule/create
export const FOOD_TABLE_DIARY_RULE_CREATE = "FOOD_TABLE_DIARY_RULE_CREATE";
export const FOOD_TABLE_DIARY_RULE_CREATE_SUCCESS =
  "FOOD_TABLE_DIARY_RULE_CREATE_SUCCESS";
export const FOOD_TABLE_DIARY_RULE_CREATE_FAIL =
  "FOOD_TABLE_DIARY_RULE_CREATE_FAIL";

///foodtablediaryrule/update
export const FOOD_TABLE_DIARY_RULE_UPDATE = "FOOD_TABLE_DIARY_RULE_UPDATE";
export const FOOD_TABLE_DIARY_RULE_UPDATE_SUCCESS =
  "FOOD_TABLE_DIARY_RULE_UPDATE_SUCCESS";
export const FOOD_TABLE_DIARY_RULE_UPDATE_FAIL =
  "FOOD_TABLE_DIARY_RULE_UPDATE_FAIL";

///foodtablediaryrule/delete
export const FOOD_TABLE_DIARY_RULE_DELETE = "FOOD_TABLE_DIARY_RULE_DELETE";
export const FOOD_TABLE_DIARY_RULE_DELETE_SUCCESS =
  "FOOD_TABLE_DIARY_RULE_DELETE_SUCCESS";
export const FOOD_TABLE_DIARY_RULE_DELETE_FAIL =
  "FOOD_TABLE_DIARY_RULE_DELETE_FAIL";

//FOOD_TABLE_REORDER (Task 24634)
export const FOOD_TABLE_REORDER = "FOOD_TABLE_REORDER";
export const FOOD_TABLE_REORDER_SUCCESS = "FOOD_TABLE_REORDER_SUCCESS";
export const FOOD_TABLE_REORDER_FAIL = "FOOD_TABLE_REORDER_FAIL";

//FOOD_TABLE_FLOORPLAN_SAVE (Task 24625)
export const FOOD_TABLE_FLOORPLAN_SAVE = "FOOD_TABLE_FLOORPLAN_SAVE";
export const FOOD_TABLE_FLOORPLAN_SAVE_SUCCESS =
  "FOOD_TABLE_FLOORPLAN_SAVE_SUCCESS";
export const FOOD_TABLE_FLOORPLAN_SAVE_FAIL = "FOOD_TABLE_FLOORPLAN_SAVE_FAIL";

export const FOOD_TABLE_DIARY_RULE_REORDER = "FOOD_TABLE_DIARY_RULE_REORDER";
export const FOOD_TABLE_DIARY_RULE_REORDER_SUCCESS =
  "FOOD_TABLE_DIARY_RULE_REORDER_SUCCESS";
export const FOOD_TABLE_DIARY_RULE_REORDER_FAIL =
  "FOOD_TABLE_DIARY_RULE_REORDER_FAIL";

///foodtablediaryrule/search
export const FOOD_TABLE_DIARY_RULE_SEARCH = "FOOD_TABLE_DIARY_RULE_SEARCH";
export const FOOD_TABLE_DIARY_RULE_SEARCH_SUCCESS =
  "FOOD_TABLE_DIARY_RULE_SEARCH_SUCCESS";
export const FOOD_TABLE_DIARY_RULE_SEARCH_FAIL =
  "FOOD_TABLE_DIARY_RULE_SEARCH_FAIL";

///foodtablediaryrule/search/bytimeslot
export const FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT =
  "FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT";
export const FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT_SUCCESS =
  "FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT_SUCCESS";
export const FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT_FAIL =
  "FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT_FAIL";

///foodtable/search
export const FOOD_TABLE_SEARCH = "FOOD_TABLE_SEARCH";
export const FOOD_TABLE_SEARCH_SUCCESS = "FOOD_TABLE_SEARCH_SUCCESS";
export const FOOD_TABLE_SEARCH_FAIL = "FOOD_TABLE_SEARCH_FAIL";

//***Booking Duration Rule (FoodTableReservationDurationRule)***
///foodtablereservationdurationrule/search
export const FOOD_TABLE_DURATION_RULE_SEARCH = "FOOD_TABLE_DURATION_RULE_SEARCH";
export const FOOD_TABLE_DURATION_RULE_SEARCH_SUCCESS =
  "FOOD_TABLE_DURATION_RULE_SEARCH_SUCCESS";
export const FOOD_TABLE_DURATION_RULE_SEARCH_FAIL =
  "FOOD_TABLE_DURATION_RULE_SEARCH_FAIL";
///foodtablereservationdurationrule/data
export const FOOD_TABLE_DURATION_RULE_DATA = "FOOD_TABLE_DURATION_RULE_DATA";
export const FOOD_TABLE_DURATION_RULE_DATA_SUCCESS =
  "FOOD_TABLE_DURATION_RULE_DATA_SUCCESS";
export const FOOD_TABLE_DURATION_RULE_DATA_FAIL =
  "FOOD_TABLE_DURATION_RULE_DATA_FAIL";
///foodtablereservationdurationrule/create
export const FOOD_TABLE_DURATION_RULE_CREATE = "FOOD_TABLE_DURATION_RULE_CREATE";
export const FOOD_TABLE_DURATION_RULE_CREATE_SUCCESS =
  "FOOD_TABLE_DURATION_RULE_CREATE_SUCCESS";
export const FOOD_TABLE_DURATION_RULE_CREATE_FAIL =
  "FOOD_TABLE_DURATION_RULE_CREATE_FAIL";
///foodtablereservationdurationrule/update
export const FOOD_TABLE_DURATION_RULE_UPDATE = "FOOD_TABLE_DURATION_RULE_UPDATE";
export const FOOD_TABLE_DURATION_RULE_UPDATE_SUCCESS =
  "FOOD_TABLE_DURATION_RULE_UPDATE_SUCCESS";
export const FOOD_TABLE_DURATION_RULE_UPDATE_FAIL =
  "FOOD_TABLE_DURATION_RULE_UPDATE_FAIL";
///foodtablereservationdurationrule/delete
export const FOOD_TABLE_DURATION_RULE_DELETE = "FOOD_TABLE_DURATION_RULE_DELETE";
export const FOOD_TABLE_DURATION_RULE_DELETE_SUCCESS =
  "FOOD_TABLE_DURATION_RULE_DELETE_SUCCESS";
export const FOOD_TABLE_DURATION_RULE_DELETE_FAIL =
  "FOOD_TABLE_DURATION_RULE_DELETE_FAIL";

///foodtablearea/search
export const FOOD_TABLE_AREA_SEARCH = "FOOD_TABLE_AREA_SEARCH";
export const FOOD_TABLE_AREA_SEARCH_SUCCESS = "FOOD_TABLE_AREA_SEARCH_SUCCESS";
export const FOOD_TABLE_AREA_SEARCH_FAIL = "FOOD_TABLE_AREA_SEARCH_FAIL";

///foodtablerule/search
export const FOOD_TABLE_RULE_SEARCH = "FOOD_TABLE_RULE_SEARCH";
export const FOOD_TABLE_RULE_SEARCH_SUCCESS = "FOOD_TABLE_RULE_SEARCH_SUCCESS";
export const FOOD_TABLE_RULE_SEARCH_FAIL = "FOOD_TABLE_RULE_SEARCH_FAIL";

///foodtablereservationtableassignment/pdf/runningorder
export const FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER =
  "FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER";
export const FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER_SUCCESS =
  "FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER_SUCCESS";
export const FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER_FAIL =
  "FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER_FAIL";

///foodtablereservation/checkavailability
export const FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY =
  "FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY";
export const FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY_SUCCESS =
  "FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY_SUCCESS";
export const FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY_FAIL =
  "FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY_FAIL";

/////foodtablereservation/search Single customer search
export const FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER =
  "FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER";
export const FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER_SUCCESS =
  "FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER_SUCCESS";
export const FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER_FAIL =
  "FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER_FAIL";
///foodtablejoin/list
export const FOOD_TABLE_JOIN_LIST = "FOOD_TABLE_JOIN_LIST";
export const FOOD_TABLE_JOIN_LIST_SUCCESS = "FOOD_TABLE_JOIN_LIST_SUCCESS";
export const FOOD_TABLE_JOIN_LIST_FAIL = "FOOD_TABLE_JOIN_LIST_FAIL";
///foodtablejoin/data
export const FOOD_TABLE_JOIN_DATA = "FOOD_TABLE_JOIN_DATA";
export const FOOD_TABLE_JOIN_DATA_SUCCESS = "FOOD_TABLE_JOIN_DATA_SUCCESS";
export const FOOD_TABLE_JOIN_DATA_FAIL = "FOOD_TABLE_JOIN_DATA_FAIL";
///foodtablejoin/create
export const FOOD_TABLE_JOIN_CREATE = "FOOD_TABLE_JOIN_CREATE";
export const FOOD_TABLE_JOIN_CREATE_SUCCESS = "FOOD_TABLE_JOIN_CREATE_SUCCESS";
export const FOOD_TABLE_JOIN_CREATE_FAIL = "FOOD_TABLE_JOIN_CREATE_FAIL";
///foodtablejoin/delete
export const FOOD_TABLE_JOIN_DELETE = "FOOD_TABLE_JOIN_DELETE";
export const FOOD_TABLE_JOIN_DELETE_SUCCESS = "FOOD_TABLE_JOIN_DELETE_SUCCESS";
export const FOOD_TABLE_JOIN_DELETE_FAIL = "FOOD_TABLE_JOIN_DELETE_FAIL";
///foodtablejoin/search
export const FOOD_TABLE_JOIN_SEARCH = "FOOD_TABLE_JOIN_SEARCH";
export const FOOD_TABLE_JOIN_SEARCH_SUCCESS = "FOOD_TABLE_JOIN_SEARCH_SUCCESS";
export const FOOD_TABLE_JOIN_SEARCH_FAIL = "FOOD_TABLE_JOIN_SEARCH_FAIL";
///foodpreordersitelocationfloorplanobject/list
export const FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST =
  "FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST";
export const FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST_SUCCESS =
  "FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST_SUCCESS";
export const FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST_FAIL =
  "FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST_FAIL";
///foodpreordersitelocationfloorplanobject/data
export const FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA =
  "FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA";
export const FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA_SUCCESS =
  "FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA_SUCCESS";
export const FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA_FAIL =
  "FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA_FAIL";
///foodpreordersitelocationfloorplanobject/create
export const FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE =
  "FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE";
export const FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE_SUCCESS =
  "FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE_SUCCESS";
export const FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE_FAIL =
  "FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE_FAIL";
///foodpreordersitelocationfloorplanobject/update
export const FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE =
  "FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE";
export const FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE_SUCCESS =
  "FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE_SUCCESS";
export const FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE_FAIL =
  "FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE_FAIL";
///foodpreordersitelocationfloorplanobject/delete
export const FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE =
  "FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE";
export const FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE_SUCCESS =
  "FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE_SUCCESS";
export const FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE_FAIL =
  "FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE_FAIL";